import React from "react";

export const Header = () => {
  return (
    <header>
      <h1 className="app-title">SpendWise — Smart Expense Tracker</h1>
    </header>
  );
};
